// Client-side order status constants and transition matrix.
// Must mirror the server's VALID_TRANSITIONS in
// silo/rules-engine/src/server/rules/order/willUpdate_order_order.js —
// keep the two in sync by hand (the UI and backend cannot share code).

export const STATUS_IN_PROGRESS = { _id: '69a9e2b19a008f25bef0de84', title: 'In Progress', color: 'Periwinkle' };
export const STATUS_IN_PROGRESS_OVER = { _id: '69a9e2b19a008f25bef0de8e', title: 'In Progress-Over', color: 'Red' };
export const STATUS_SUSPENDED = { _id: '69a9e2b19a008f25bef0de85', title: 'Suspended', color: 'Teal' };
export const STATUS_CLOSED = { _id: '69a9e2b19a008f25bef0de86', title: 'Closed', color: 'Green' };
export const STATUS_CLOSED_SHORT = { _id: '69a9e2b19a008f25bef0de87', title: 'Closed-Short', color: 'Yellow Green' };
export const STATUS_CLOSED_OVER = { _id: '69a9e2b19a008f25bef0de88', title: 'Closed-Over', color: 'Red' };

export const VALID_TRANSITIONS = {
    'New': ['In Progress', 'Cancelled'],
    'In Progress': ['In Progress-Over', 'Suspended', 'Closed', 'Closed-Short', 'Closed-Over', 'Cancelled'],
    'In Progress-Over': ['In Progress', 'Suspended', 'Closed', 'Closed-Over', 'Cancelled'],
    'Suspended': ['In Progress', 'In Progress-Over', 'Cancelled'],
    'Closed': [],
    'Closed-Short': [],
    'Closed-Over': [],
    'Cancelled': []
};

/**
 * @param {string | undefined} fromStatus
 * @param {string} toStatus
 * @returns {boolean}
 */
export function canTransition(fromStatus, toStatus) {
    return VALID_TRANSITIONS[fromStatus]?.includes(toStatus) ?? false;
}
